import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CenterCampaignExpenseReport from "../components/CenterCampaingExpenseReport";
const CampaignExpensePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Centers Campaign Expense Report" />

        <CenterCampaignExpenseReport />

      </MasterLayout>
    </>
  );
};

export default CampaignExpensePage;
